<template>
  <div class="report-view">
    <CRow>
      <CCol md="12" class="pr-0">
        <CCard class="mb-2">
          <CCardHeader class="pt-1 pb-1">
            <h4>Báo cáo quyết toán</h4>
          </CCardHeader>
          <CCardBody class="pt-1 pb-1">
            <CRow class="mb-2">
              <CCol md="8">
                <CSelect
                  :value.sync="inputCate"
                  label="Báo cáo"
                  :options="listSearchCate"
                />
              </CCol>
              <CCol md="4">
                <CSelect
                  :value.sync="inputReportYear"
                  label="Năm"
                  :options="listSearchYear"
                />
                <!-- <CInput v-model="inputReportYear" type="number" label="Năm" /> -->
              </CCol>
            </CRow>
            <CRow class="mb-2 center">
              <div class="center">
                <vs-button
                  square
                  @click="getData"
                  class="m-auto custom_btn_search"
                  ><i class="bx bx-search"></i>&nbsp;Tìm kiếm</vs-button
                >
              </div>
              <div class="center">
                <vs-button square @click="exportXml" class="m-auto"
                  ><i class="bx bxs-file-export"></i>&nbsp;Xuất excel</vs-button
                >
              </div>
            </CRow>
          </CCardBody>
        </CCard>
        <CCard class="mb-2" style="overflow-x: scroll;">
          <vuetable :fields="columns" :css="csstable" :data="tableData"
            ><template slot="tableHeader">
              <template>
                <tr>
                  <th
                    v-for="header in headerRows"
                    :key="header.label"
                    :colspan="header.colspan"
                    style="text-align:center ; border-right: 1px solid;  border-right-color: #d8dbe0;"
                  >
                    {{ header.label }}
                  </th>
                  <!-- <th colspan="2" style="text-align:center">Details</th> -->
                </tr>
                <tr>
                  <th
                    v-for="header in headerRowsTwo"
                    :key="header.label"
                    :colspan="header.colspan"
                    style="text-align:center ; border-right: 1px solid; border-right-color: #d8dbe0;"
                  >
                    {{ header.label }}
                  </th>
                  <!-- <th colspan="2" style="text-align:center">Details</th> -->
                </tr>
                <tr>
                  <th
                    v-for="header in headerRowsThree"
                    :key="header.label"
                    :colspan="header.colspan"
                    style="text-align:center ; border-right: 1px solid; border-right-color: #d8dbe0;"
                  >
                    {{ header.label }}
                  </th>
                  <!-- <th colspan="2" style="text-align:center">Details</th> -->
                </tr>
              </template>
              <vuetable-row-header></vuetable-row-header> </template
          ></vuetable>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
// import ListFile from "../../../components/files/ListFile";
const api = ClientFactory.get("databasefinance");
const apiDropdown = ClientFactory.get("dropdowns");
//import listCategory from "@/components/budgetreport/ListCategory";
import Vuetable from "vuetable-2/src/components/Vuetable.vue";
import VuetableRowHeader from "vuetable-2/src/components/VuetableRowHeader.vue";

export default {
  components: {
    Vuetable,
    VuetableRowHeader,
  },
  data() {
    return {
      token: "",
      inputReportYear: new Date().getFullYear() - 2,
      inputCircularsTemplateNo: "",
      inputCircularsNo: "",
      inputCate: "BM63-CK-NSNN",
      listSearchCate: [],
      listSearchYear: [],
      listYear: [],
      listCate: [],
      headerRows: [],
      headerRowsTwo: [],
      headerRowsThree: [],
      columns: [],
      tableData: [],
      file_data: [],
      state: {
        dialog: {
          files: false,
        },
      },
      csstable: {
        tableWrapper: "",
        tableHeaderClass: "",
        tableBodyClass: "mb-0",
        tableClass: "table ui celled padded",
        loadingClass: "loading",
        detailRowClass: "vuetable-detail-row",
        handleIcon: "fa fa-bars text-secondary",
      },
    };
  },
  methods: {
    ...mapActions("ui", ["loading", "closeLoading", "notify"]),
    async getData() {
      this.tableData = [];
      this.loading(this.$vs);
      // Chỉ filter các báo cáo ở trạng thái công khai: Trạng thái: 0 - không sử dụng, 1 - sử dụng, 2 - công khai
      const { data } = await api.searchSettlement(
        this.inputReportYear,
        this.inputCate
      );
      this.checkResponseData(data);
      this.closeLoading();
    },
    async exportXml() {
      this.loading(this.$vs);
      const filter = {
        reportCode: this.inputCate,
        maDonVi: "T55",
        maKyBC: "NAM",
        namBC: this.inputReportYear,
      };
      await api.getFileQT(filter);

      this.closeLoading();
    },
    checkResponseData(data) {
      if (data.status == "success") {
        if (data.data) {
          this.tableData = data.data[0].data;
          this.headerRows = data.data[0].headerRows;
          this.headerRowsTwo = data.data[0].headerRowsTwo;
          this.headerRowsThree = data.data[0].headerRowsThree;
          this.columns = data.data[0].columns;
        } else this.tableData = [];
      } else {
        if (data.message != "Xin lỗi, không có dữ liệu") {
          this.notify({
            error: true,
            title: "Thông báo",
            text: data.message,
          });
        }
      }
    },
  },
  async created() {
    /// LIST BAO CAO
    if (this.$route.query.cateId != undefined)
      this.inputCate = this.$route.query.cateId || "BM63-CK-NSNN";
    this.loading(this.$vs);
    this.listCate = await apiDropdown.getDatabaseFinance_qt();
    for (var i = 0; i < this.listCate.data.data.length; i++) {
      this.listSearchCate.push(this.listCate.data.data[i]);
    }

    // NAM
    if (this.$route.query.year != undefined)
      this.inputReportYear = this.$route.query.year;
    // this.loading(this.$vs);
    this.listYear = await apiDropdown.get("years");
    for (var j = 0; j < this.listYear.length; j++) {
      this.listSearchYear.push(this.listYear[j]);
    }
    this.closeLoading();
    await this.getData();
  },
  mounted() {
    this.$root.$on("ReportViewerChangeCategory", (cateId) => {
      this.inputCate = cateId;
      this.getData();
    });
  },
  destroyed() {
    this.closeLoading();
  },
};
</script>

<style lang="scss">
.report-view {
  .table-right {
    text-align: right;
  }
  .table-left {
    text-align: left;
    border-right: 1px solid;
    border-right-color: #d8dbe0;
  }

  .table-center {
    text-align: center;
    border-right: 1px solid;
    border-right-color: #d8dbe0;
  }
  .table-bold {
    font-weight: bold;
  }
}
</style>
